import React from 'react';
import { Modal } from 'react-bootstrap';
import { Warning48Filled } from '@fluentui/react-icons';
import styles from '../CommonComponents/DoubleConfirmationModal/DoubleConfirmationModal.module.css';

const FIRST_MESSAGE =
    "Adding a subtask will turn this task into a parent. Its Timeline, Duration, Status and Mode will no longer be managed independently and will instead be calculated from its subtasks. Existing schedule values may be transferred to the first subtask. The parent's existing Deadline will be cleared and will then follow the rolled-up End Date unless you set it manually.";

const SubtaskParentWarningModal = ({ open, onClose, onConfirm, confirmLoading = false }) => {
    const [step, setStep] = React.useState(1);

    React.useEffect(() => {
        if (open) setStep(1);
    }, [open]);

    const handleClose = () => {
        if (confirmLoading) return;
        setStep(1);
        onClose();
    };

    const icon = (
        <div className="mb-4 text-center">
            <Warning48Filled color="var(--Brand-Primary)" />
        </div>
    );

    if (step === 1) {
        return (
            <Modal centered show={open} onHide={handleClose} className={styles.modalMainBody}>
                <Modal.Body className={styles.confirmationModalBody}>
                    <div className={styles.confirmationModalMsg}>
                        {icon}
                        <p className={styles.message}>{FIRST_MESSAGE}</p>
                        <div className="d-flex justify-content-between align-items-center">
                            <button type="button" onClick={handleClose} className={styles.secondaryBtn}>
                                Cancel
                            </button>
                            <span role="button" onClick={() => setStep(2)} className={styles.orangeLink}>
                                Continue
                            </span>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }

    return (
        <Modal centered show={open} onHide={handleClose} className={styles.modalMainBody}>
            <Modal.Body className={styles.confirmationModalBody}>
                <div className={styles.confirmationModalMsg}>
                    {icon}
                    <p className={`${styles.message} mb-0`}>Are you sure?</p>
                    <p className={styles.message}>This changes the scheduling structure of the task and cannot be automatically undone.</p>
                    <div className="d-flex justify-content-between align-items-center">
                        <span
                            role="button"
                            onClick={() => {
                                if (!confirmLoading) onConfirm();
                            }}
                            className={styles.orangeLink}
                            style={{ opacity: confirmLoading ? 0.6 : 1, pointerEvents: confirmLoading ? 'none' : 'auto' }}>
                            Add subtask
                        </span>
                        <button type="button" onClick={handleClose} className={styles.secondaryBtn} disabled={confirmLoading}>
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SubtaskParentWarningModal;
